import React, { FC } from 'react';
import { Divider, List, ListItem, Stack, Typography } from '@mui/material';
import styles from './DataList.module.scss';

export interface DataListItem {
    key?: string,
    name: string,
    value: string,
    prefix?: React.ReactNode,
}

interface DataListProps {
    dataListItems: DataListItem[];
}

const DataList: FC<DataListProps> = (props) => {
    const { dataListItems } = props;

    return (
        <div className={styles.DataList} data-testid="DataList">
            <List
                sx={{ p: 0 }}
            >
                {dataListItems?.map((item) => (
                    <React.Fragment key={item.name}>
                        <ListItem
                            disableGutters
                        >
                            <Stack
                                sx={{ width: '100%', py: 2 }}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="flex-start"
                                spacing={2}
                            >
                                <Stack direction="row" spacing={1}>
                                    {item.prefix}
                                    <Typography
                                        className={styles.LabelText}
                                        sx={{
                                            fontWeight: '400',
                                            fontSize: '1.125rem',
                                            lineHeight: '21px',
                                        }}
                                    >
                                        {item.name}
                                    </Typography>
                                </Stack>
                                <Typography
                                    sx={{
                                        fontWeight: '400',
                                        fontSize: '1.125rem',
                                        lineHeight: '21px',
                                        textAlign: 'right',
                                    }}
                                >
                                    {item.value}
                                </Typography>
                            </Stack>
                        </ListItem>
                        <Divider
                            component="li"
                        />
                    </React.Fragment>
                ))}
            </List>
        </div>
    );
};

export default DataList;
